<template>
  <section id="badges">
    <div class="demo">
      <h5>Badges</h5>
      <p>
        <span class="badge badge-info">Information</span> &nbsp;&nbsp;
        <span class="badge badge-success">Success</span>&nbsp;&nbsp;
        <span class="badge badge-danger">Danger</span>&nbsp;&nbsp;
        <span class="badge badge-warning">Warning</span>&nbsp;&nbsp;
        <span class="badge badge-light">Light</span>&nbsp;&nbsp;
        <span class="badge badge-dark">Dark</span>
      </p>
      <h6>Linkable badges</h6>
      <p>
        <a href="#"><span class="badge badge-info">Information</span></a> &nbsp;&nbsp;
        <a href="#"><span class="badge badge-success">Success</span></a>&nbsp;&nbsp;
      </p>
      <h5 class="mt-5">Dots</h5>
      <p>
        <span class="dot-green"></span> &nbsp;&nbsp;
        <span class="dot-blue"></span>&nbsp;&nbsp;
        <span class="dot-red"></span>&nbsp;&nbsp;
        <span class="dot-orange"></span>&nbsp;&nbsp;
        <span class="dot-gray"></span>
      </p>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/components/badges.md";
export default {
  name: "badges",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.badges.name);
    this.$emit("update-tagline", this.$root.yamlData.components.badges.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
